import myNetwork from '@/mycore/network/apimanagement';
import * as api from '../../../mycore/module/api';

export function updateSurvey(callback, dataStep1) {
    myNetwork
        .post('/fptplaybox-api/update-survey', dataStep1)
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function payment(callback, dataStep1) {
    myNetwork
        .post('/fptplaybox-api/payment', dataStep1)
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function paymentDomestic(callback, dataStep1) {
    myNetwork
        .post('/fptplaybox-api/payment-domestic', dataStep1)
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function paymentInternational(callback, dataStep1) {
    myNetwork
        .post('/fptplaybox-api/payment-international', dataStep1)
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function paymentMomo(callback, dataStep1) {
    myNetwork
        .post('/fptplaybox-api/payment-momo', dataStep1)
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function paymentVnpay(callback, dataStep1) {
    myNetwork
        .post('/fptplaybox-api/payment-vnpay', dataStep1)
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function paymentOnline(callback, dataStep1) {
    myNetwork
        .post('/fptplaybox-api/payment-online', dataStep1)
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function updatePackageOrder(callback, dataStep1) {
    myNetwork
        .post('/fptplaybox-api/update-package-order', dataStep1)
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function checkPayment(callback, ordercode) {
    myNetwork
        .post('/fptplaybox-api/check-payment', { ordercode: ordercode })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function tracking(callback, ordercode) {
    myNetwork
        .post('/fptplaybox-api/tracking', { ordercode: ordercode })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
export function reportPTTB(callback) {
    myNetwork
        .get('/posts')
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function checkPassport(callback, passport, type, captcha) {
    api.checkPassport(callback, 'cloud', passport, captcha);
}

export function getPackagesFee(callback, serviceCode) {
    api.getPackagesFee(callback, serviceCode);
}

export function getOrderInfo(callback, ordercode) {
    api.getOrderInfo(callback, ordercode);
}


export function getFeaturedNews(callback) {
    myNetwork
        .post('/api/cms/news', {
            service_code: 'fpt-play',
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
// dich vu lien quan
export function getCategoriesRelated(callback,orderId) {
    myNetwork
        .post('/api/saleplatform/catalog/get-category-related', {
            OrderId: orderId,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
// dich vu lien quan
export function getCateRelated(callback,orderId) {
    myNetwork
        .post('/api/saleplatform/catalog/get-categories-related', {
            OrderId: orderId,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
// Khach hàng tiềm năng
export function getPotentialCustomer(callback,orderId) {
    myNetwork
        .post('/api/saleplatform/customer/push-potential-customer', {
            OrderId: orderId,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
// Lấy thông tin sản phẩm
export function getOrderDetail(callback,orderId) {
    myNetwork
        .post('/api/saleplatform/order/get-order-detail', {
            OrderId: orderId,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
// Lấy thông tin nợ cước
export function getOrderDetailOfDebtcharges(callback,orderId) {
    myNetwork
        .post('/api/saleplatform/order/get-order-detail-of-debt-charges', {
            OrderId: orderId,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
// Lấy thông tin setting

export function getSetting(callback, saleTeamId,orderid = 0, billType) {
    myNetwork.post('/api/saleplatform/configuration/get-saleteam-setting', {
            "SaleTeamId": saleTeamId,
            "OrderID": orderid,
            "BillType": billType,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
export function getListVoucher(callback, orderid, paymentType) {
    myNetwork.post('/api/saleplatform/voucher/list', {
        OrderId: orderid,
        PaymentType: paymentType })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
//Get list voucher from cache BE
export function getListVoucherApplied(callback, order_id, paid_type_payment) {
    myNetwork.post('/api/saleplatform/voucher/list-apply-voucher', {
            OrderId: order_id,
            PaidTypePayment: paid_type_payment
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, {
                message: error
            });
        });
}
export function removeVoucher(callback, OrderId, VoucherCode) {
    myNetwork.post('/api/saleplatform/voucher/remove-voucher', {
            OrderId: OrderId,
            Code: VoucherCode,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

export function getTotalOrder(callback, orderid) {
    myNetwork
        .post('/api/saleplatform/order/get-total-order', {
            OrderId: orderid,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
// check voucher
export function checkExistVoucher(callback, voucher_code, input_type) {
    myNetwork.post('/api/saleplatform/voucher/check-voucher', {
            "Vouchers": [
                {
                "Code": voucher_code,
                "InputType": input_type
                }
            ]
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
// add-promotion-automatically
export function addPromotionVoucher(callback, order_id, paid_type_payment) {
    myNetwork.post('/api/saleplatform/voucher/add-promotion-automatically', {
            OrderId: order_id,
            PaidTypePayment: paid_type_payment,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
export function checkOTP(callback, orderId, code) {
    api.checkOTP(callback, orderId, code);
}
export function sendOTP(callback, orderId, paidType) {
    api.sendOTP(callback, orderId, paidType);
}
